// Value readers shared by wire.ts and crewWire.ts. Wire data is untrusted: a
// value of the wrong type reads as missing, never as a crash.

export const str = (value: unknown): string | undefined =>
  typeof value === 'string' ? value : undefined;

export const scalar = (value: unknown): string | number | boolean | null =>
  typeof value === 'string' ||
  typeof value === 'number' ||
  typeof value === 'boolean'
    ? value
    : null;
